import { idb } from "../db/index.ts";
import { g } from "../util/index.ts";
import type { UpdateEvents, ViewInput } from "../../common/types.ts";

const updateReportCard = async (
	inputs: ViewInput<"reportCard">,
	updateEvents: UpdateEvents,
	state: {
		season?: number;
		tid?: number;
	},
) => {
	if (
		updateEvents.includes("firstRun") ||
		updateEvents.includes("newPhase") ||
		updateEvents.includes("gameSim") ||
		inputs.season !== state.season ||
		inputs.tid !== state.tid
	) {
		// All teams' seasons for this year (works for historical seasons too).
		const teamSeasons = await idb.getCopies.teamSeasons(
			{ season: inputs.season },
			"noCopyCache",
		);

		// League leaderboard: every team that has a computed card, ranked by GM Score.
		const ranked = teamSeasons
			.filter((ts) => ts.reportCard)
			.sort(
				(a, b) => (b.reportCard?.gmScore ?? 0) - (a.reportCard?.gmScore ?? 0),
			);

		const leaderboard = ranked.map((ts) => ({
			tid: ts.tid,
			abbrev: ts.abbrev,
			region: ts.region,
			name: ts.name,
			gmScore: ts.reportCard!.gmScore,
			grade: ts.reportCard!.grade,
			champion: ts.reportCard!.champion,
		}));

		const ts = teamSeasons.find((row) => row.tid === inputs.tid);
		const card = ts?.reportCard;
		const rankIndex = ranked.findIndex((row) => row.tid === inputs.tid);

		const t = g.get("teamInfoCache")[inputs.tid];

		return {
			abbrev: inputs.abbrev,
			tid: inputs.tid,
			season: inputs.season,
			teamName: t ? `${t.region} ${t.name}` : inputs.abbrev,
			imgURL: t?.imgURL,
			card,
			won: ts?.won ?? 0,
			lost: ts?.lost ?? 0,
			projectedWins: ts?.projectedWins,
			playoffRoundsWon: ts?.playoffRoundsWon ?? -1,
			numPlayoffRounds: g.get("numGamesPlayoffSeries", inputs.season).length,
			rank: card && rankIndex >= 0 ? rankIndex + 1 : undefined,
			numRanked: ranked.length,
			leaderboard,
			userTid: g.get("userTid"),
		};
	}
};

export default updateReportCard;
